import React from 'react'
import { ReactComponent as EyeOpenIcon } from '../../assets/icons/old/eye.svg'
import { ReactComponent as EyeCloseIcon } from '../../assets/icons/eye-close.svg'

const EyeIcon = ({ isHidden }) => {
    return isHidden ? <EyeCloseIcon /> : <EyeOpenIcon />
}

export default EyeIcon
